module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "short-page"
  }, [(_vm.msg) ? _c('ui-alert', {
    attrs: {
      "type": "error",
      "dismissible": false
    }
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e(), _vm._v(" "), _c('panel', [_c('p', {
    slot: "header"
  }, [_vm._v("Zaloguj się")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ui-textbox', {
    attrs: {
      "label": "Twój e-mail",
      "name": "email",
      "type": "text",
      "autofocus": _vm.autofocus
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = $$v
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Twoje hasło",
      "name": "password",
      "type": "password"
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = $$v
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("Zaloguj")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4edbed7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = 257
// module chunks = 0